module.exports = __webpack_public_path__ + "GroupRol.png";